import { FilePath } from '../models/git-worker.model';
import type { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitAddAction extends WorkerAction {
  type: GitAction.Add;
  params?: {
    files: FilePath[];
  };
}

export async function GitAddActionFn({ lg, util, params }: WorkerFnParams<GitAddAction>): Promise<void> {
  lg.callAndCaptureOutput(['add', ...(params ? params.files : ['.'])]);
  await util.syncfs(false);
}
